module.exports = __webpack_public_path__ + "img/banner-shopby-class.cb530b79.png";